import { EFamilyPersonRole, } from "../../../../domains/entities/Reports/Familytagging/MyFamiliesResponsEntity";
export const MyFamiliesMapper = (response) => {
    var _a, _b;
    let FamilyDetailsMain = {
        myFamilies: {},
        myAccCode: response.myAccCode,
        UserIsManagerOfFamilyId: "1",
        UserIsManagerInMinOneFamily: false, // true if user is manager atleast in 1 family
    };
    let meAndMyFamilies = {
        myDataInFam: undefined,
        familiDetails: FamilyDetailsMain,
    };
    if ((response === null || response === void 0 ? void 0 : response.data) && ((_b = Object.keys((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : {})) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        Object.entries(response === null || response === void 0 ? void 0 : response.data).map(([familyName, members], familyIdx) => {
            let myIndexInFam = members.findIndex((member) => (member === null || member === void 0 ? void 0 : member.accCode) === response.myAccCode);
            let myDataInThisfam = null;
            if (myIndexInFam >= 0) {
                const [member] = members.splice(myIndexInFam, 1);
                myDataInThisfam = Object.assign(Object.assign({}, member), { familyIdx: familyIdx });
                members.unshift(member);
            }
            if (!(meAndMyFamilies === null || meAndMyFamilies === void 0 ? void 0 : meAndMyFamilies.myDataInFam) && myDataInThisfam)
                meAndMyFamilies.myDataInFam = myDataInThisfam;
            if (!FamilyDetailsMain.UserIsManagerInMinOneFamily &&
                (myDataInThisfam === null || myDataInThisfam === void 0 ? void 0 : myDataInThisfam.role) === EFamilyPersonRole.MANAGER) {
                FamilyDetailsMain.UserIsManagerInMinOneFamily = true;
                FamilyDetailsMain.UserIsManagerOfFamilyId = familyName;
            }
            FamilyDetailsMain.myFamilies[familyName] = {
                familyName: familyName.length == 1 ? `Family ${familyName}` : familyName,
                members: members.map((member) => (Object.assign(Object.assign({}, member), { familyIdx: familyIdx }))),
                myRole: (myDataInThisfam === null || myDataInThisfam === void 0 ? void 0 : myDataInThisfam.role)
                    ? myDataInThisfam === null || myDataInThisfam === void 0 ? void 0 : myDataInThisfam.role
                    : EFamilyPersonRole.MEMBER,
                familyIdx: familyIdx,
            };
        });
    }
    else {
        meAndMyFamilies.myDataInFam = {
            head: response === null || response === void 0 ? void 0 : response.myAccCode,
            memberName: "You",
            accCode: response === null || response === void 0 ? void 0 : response.myAccCode,
            permission: "",
            role: EFamilyPersonRole.MEMBER,
            familyIdx: 0,
        };
    }
    return meAndMyFamilies;
};
export const createSortName = (memberFullName) => {
    var _a, _b;
    let names = (_b = (_a = memberFullName === null || memberFullName === void 0 ? void 0 : memberFullName.split(" ")) === null || _a === void 0 ? void 0 : _a.filter((name) => !!name)) !== null && _b !== void 0 ? _b : [];
    if (names.length >= 3)
        return (names[0][0] + names[2][0]).toUpperCase();
    else if (names.length === 2)
        return (names[0][0] + names[1][0]).toUpperCase();
    else if (names.length === 1)
        return names[0][0].toUpperCase();
};
